import {S3Client} from '@aws-sdk/client-s3';

export interface S3Config {
  bucket: string;
  region: string;
  accessKeyId: string;
  secretAccessKey: string;
}

export const s3Config: S3Config = {
  bucket: import.meta.env.VITE_AWS_STORAGE_BUCKET_NAME,
  region: import.meta.env.VITE_AWS_S3_REGION_NAME,
  accessKeyId: import.meta.env.VITE_AWS_ACCESS_KEY_ID,
  secretAccessKey: import.meta.env.VITE_AWS_SECRET_ACCESS_KEY,
};

export const s3Client = new S3Client({
  region: s3Config.region,
  credentials: {
    accessKeyId: s3Config.accessKeyId,
    secretAccessKey: s3Config.secretAccessKey,
  },
});
